import { c as _c } from "react/compiler-runtime";
import { cn } from '@module/lib/utils';
import useChatMessageStore from '@module/stores/useChatMessageStore';
import { ArrowUp } from '@module/svg/icons';
import { isItemCoinMessage, isSponCoinMessage } from '@module/types/centrifuge/public-message/sponCoinMessageTypes';
import { useState } from 'react';
function SponSummary() {
  const $ = _c(14);
  const [isOpen, setIsOpen] = useState(false);
  const sponMessages = useChatMessageStore(_temp);
  let sponList;
  let t0;
  let t1;
  let t2;
  if ($[0] !== isOpen || $[1] !== sponMessages) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      sponList = sponMessages.slice(-10);
      const renderSponList = isOpen ? sponList : sponList.slice(-3);
      if (sponList.length < 1) {
        let t3;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <></>;
          $[6] = t3;
        } else {
          t3 = $[6];
        }
        t2 = t3;
        break bb0;
      }
      t0 = "border-borderBg01 border-b bg-baseBg p-2.5 text-[14px] text-cht_baseFg";
      t1 = renderSponList.map(_temp2);
    }
    $[0] = isOpen;
    $[1] = sponMessages;
    $[2] = sponList;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
  } else {
    sponList = $[2];
    t0 = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  let t3;
  if ($[7] !== isOpen || $[8] !== sponList.length) {
    t3 = sponList.length > 3 && <div className="flex justify-end"><button className={cn("flex h-7 w-7 rotate-180 items-center justify-center rounded-full border-2 border-borderBg02", {
        "rotate-0": isOpen
      })} onClick={() => setIsOpen(!isOpen)}><ArrowUp style={{
          color: "var(--borderBg02)",
          fontSize: 5
        }} /></button></div>;
    $[7] = isOpen;
    $[8] = sponList.length;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t0 || $[11] !== t1 || $[12] !== t3) {
    t4 = <ul className={t0}>{t1}{t3}</ul>;
    $[10] = t0;
    $[11] = t1;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
function _temp2(item) {
  const isViewerSignature = isSponCoinMessage(item) && "heart" in item.data.message;
  const isSignature = isViewerSignature;
  const isSpecial = isItemCoinMessage(item);
  const isNormal = !isSpecial && !isSignature;
  return <li key={item.offset} className="flex items-center truncate"><span>{item.data.message.nick}님이</span> <span className="relative inline truncate"><div className="-left-1 -right-1 absolute bottom-0 block h-[6px] bg-colorBg_gift_txt_box" /><span className="relative">{isNormal && "\uD558\uD2B8"}{isSpecial && "\uC2A4\uD398\uC15C\uD558\uD2B8"}{isSignature && "\uC2DC\uADF8\uB2C8\uCC98\uD558\uD2B8"}</span> <span className="relative font-bold">{item.data.message.coin} 개</span><span className="relative"> 선물!</span></span></li>;
}
function _temp(state) {
  return state.sponMessages;
}
export default SponSummary;